export enum RegisterStep {
  REGISTER = 'register',
  COMPLETE_REGISTRATION = 'complete-registration',
}
